<template>
  <template v-if="isLoading">
    <div class="space-y-16">
      <RevSkeleton height="12px" shape="line" width="250px" />
      <RevSkeleton height="12px" shape="line" width="290px" />
      <RevSkeleton height="12px" shape="line" width="250px" />
    </div>
  </template>
  <template v-if="!isLoading">
    <slot />
  </template>
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'

defineProps<{
  isLoading: boolean
}>()
</script>
